<template>
  <div>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 md6 lg4 xl3>
          <v-card>
            <v-card-title primary-title>
              <div>
                <h3 class="headline mb-0">{{ event.title}}</h3>
                <v-img v-if="event.logo !== ''" class="ma-4" :src="event.logo"></v-img>
                <div> {{ event.description }}</div>
              </div>
            </v-card-title>

            <v-card-actions>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 md6 lg4 xl3 v-if="runningCategories.length > 0">
          <v-card>
            <v-card-title primary-title>
              <div>
                <h3 class="headline mb-0">Gestartete Kategorien</h3>
              </div>
            </v-card-title>
            <v-card-text>
              <v-list>
                <v-list-tile v-for="category in runningCategories" :key="category.id">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ category.title }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ category.startTime }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <CategoryStatus :category="category"></CategoryStatus>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </v-card-text>
            <v-card-actions>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 md6 lg4 xl3>
          <v-card>
            <v-card-title primary-title>
              <div>
                <h3 class="headline mb-0">Letzte Anmeldungen</h3>
                <v-data-table
                    hide-actions
                    :headers="headers"
                    :items="lastParticipants"
                    disable-initial-sort
                >
                  <template v-slot:items="props">
                    <td>{{ props.item.firstname }}</td>
                    <td>{{ props.item.lastname }}</td>
                    <td>{{ props.item.registrationDate }}</td>
                  </template>
                </v-data-table>
              </div>
            </v-card-title>
            <v-card-actions>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 md6 lg4 xl3>
          <v-card>
            <v-card-title primary-title>
              <div>
                <h3 class="headline mb-0">Auslastung der Kategorien</h3>
              </div>
            </v-card-title>
            <v-card-text>
              <v-list>
                <v-list-tile v-for="category in categoriesSortByParticipants" :key="category.id">
                  <v-list-tile-avatar>
                    <v-chip>{{ category.participants }}</v-chip>
                  </v-list-tile-avatar>
                  <v-list-tile-title>{{ category.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-card-text>
            <v-card-actions>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import CategoryStatus from "../components/CategoryStatus";
  export default {
    components: {CategoryStatus},
    computed: {
      categories () {
        return this.$store.state.categories
      },
      participants () {
        return this.$store.state.participants
      },
      categoriesSortByParticipants () {
        return [...this.$store.state.categories].sort(function(a, b){
          if(a.participants > b.participants) return -1;
          if(a.participants < b.participants) return 1;
          return 0;
        });
      },
      event () {
        return this.$store.state.event
      },
      lastParticipants () {
        return this.$store.state.participants.slice(-16).reverse()
      },
      startDate () {
        return this.transfromEnglishDateToGerman(this.event.startDate)
      },
      runningCategories () {
        return this.categories.filter(item => item.startTime !== null && item.finished !== true)
      }
    },
    data: function () {
      return {
        headers: [
          {
            text: 'Vorname',
            align: 'left',
            value: 'firstname'
          },
          {
            text: 'Nachname',
            align: 'left',
            value: 'lastname'
          },
          {
            text: 'Registrierung',
            align: 'right',
            value: 'registrationDateRaw'
          },
        ],

      }
    },
    methods: {
      progressPercent (category) {
        let participants = this.participants.filter(participant => participant.category === category.id)
        let max = participants.length
        let ready = 0;
        participants.forEach(participant => {
          if (participant.canceled === true) {
            ready++
          } else if(participant.progress === category.checkpoints.length) {
            ready++
          }
        })

        return (ready / max * 100).toFixed(0)
      }
    }
  }
</script>
